import './css/pagination.css';

const Pagination = ({ onTop, totalPages, currentPage, setPage }) => {
  return (
    <div className="pagination justify-content-center align-items-center">
      <nav className="d-flex justify-items-center justify-content-between">
        <div className="flex-sm-fill d-flex align-items-sm-center justify-content-sm-center mb-0 ">
          <div>
            <ul className="pagination justify-content-center align-items-center">
              <li
                className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
              >
                <span
                  className="page-link arrow"
                  aria-label="« Prev"
                  aria-hidden="true"
                  onClick={() => {
                    currentPage > 1 && setPage(currentPage - 1);
                    onTop();
                  }}
                >
                  «
                </span>
              </li>
              {[...Array(totalPages)].map((_, i) => (
                <li
                  key={i}
                  className={
                    currentPage === i + 1 ? 'page-item active' : 'page-item'
                  }
                  aria-current="page"
                  onClick={() => {
                    setPage(i + 1);
                    onTop();
                  }}
                >
                  <span className="page-link">{i + 1}</span>
                </li>
              ))}

              <li
                className={`page-item ${
                  currentPage === totalPages ? 'disabled' : ''
                }`}
              >
                <span
                  className="page-link arrow"
                  aria-label="Next »"
                  onClick={() => {
                    currentPage < totalPages && setPage(currentPage + 1);
                    onTop();
                  }}
                >
                  »
                </span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Pagination;
